/*-----------------------------------------------------------------
- For Developer Page
-----------------------------------------------------------------*/

export default {
    learn_more    : 'Learn more',
    for_developers: {
        title: 'For Developers',
    },
    for_marketers: {
        title: 'For Marketers',
    },
    for_creators: {
        title: 'For Creators',
    },
};
